if (!customElements.get('cfa-afterpay-checkout')) {
  customElements.define('cfa-afterpay-checkout', class extends HTMLElement {
    connectedCallback() {
      this.onclick = async (event) => {
        const button = event.target.closest('button');
        if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
        const form = button.form;
        if (!form || !form.reportValidity()) return;
        const error = this.querySelector('[role="alert"]');
        error.textContent = '';
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        let added = false;
        try {
          const data = new FormData(form);
          data.delete('sections'); data.delete('sections_url'); data.delete('on_success');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please check your selection.');
          added = true;
          window.location.assign(root + 'checkout');
        } catch (failure) {
          error.textContent = added ? 'Your item was added. Open your cart to continue to checkout.' : failure.message || 'Unable to continue. Please try again.';
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };
    }
  });
}
